<template>
    <v-card>
        <v-card-title>
            Game item event filter
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="4" style="height: 50px;">
                    <v-text-field v-model="userId" label="User ID" clearable outlined dense/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="2" md="2" style="height: 50px;">
                    <v-select v-model="platform" :items="$store.getters.platforms" label="Platform" clearable outlined dense small-chips/>
                </v-col>
                <v-col cols="2" style="height: 50px;">
<!--                    <v-text-field v-model="appVersion" label="App version" clearable outlined dense/>-->
                    <v-combobox v-model="appVersion" :items="$store.getters.versions" label="App version" clearable outlined dense small-chips/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="2" md="2" style="height: 50px;">
                    <v-select v-model="gameEvent" :items="['Spend', 'Earn']" label="Event" clearable outlined dense small-chips/>
                </v-col>
                <v-col cols="2" md="2" style="height: 50px;">
                    <v-select v-model="location" :items="['Map', 'Shop', 'Game', 'Menu', 'Fortune', 'Win_level', 'Lose_level', 'Quest', 'Daily_reward', 'Time_reward', 'Event']" label="Location" clearable outlined dense small-chips/>
                </v-col>
                <v-col cols="2" style="height: 50px;">
                    <v-text-field v-model="source" label="Source" clearable outlined dense/>
                    <!-- PurchaseGold3	 PurchasePack9	 BombHor	 Radar	 PurchasePack5	 PurchasePack6	 PurchasePack7	 PurchaseGold1	 Snowball	 PurchaseHalloween1	 PurchaseOffer1
                    PurchaseGold2	 BombVert	 PurchasePack8	 PurchaseHalloween2	 PurchaseOffer2	 PurchasePack1	 PurchaseHalloween3	 PurchaseOffer3	 Energy1	 PurchasePack2
                    PurchaseBundle1	 Energy2	 PurchasePack3	 PurchaseBundle2	 PurchasePack4	 PurchaseBundle3	 Bomb1	 Bomb2	 Bomb3	 RewardedVideo-->
                </v-col>
                <v-col cols="2" md="2" style="height: 50px;">
                    <v-select v-model="item" :items="['Coins', 'Energy', 'Bomb1', 'Bomb2', 'Bomb3', 'Bomb4', 'Bomb5', 'Bomb6', 'Bomb7']" label="Item" clearable outlined dense small-chips/>
                </v-col>
                <v-col cols="2" style="height: 50px;">
                    <v-text-field v-model="value" label="Value" clearable outlined dense/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="2" md="2" style="height: 50px;">
                    <v-select v-model="game" :items="['Campaign', 'Multiplayer', 'Classic']" label="Game" clearable outlined dense small-chips/>
                </v-col>
                <v-col cols="2" style="height: 50px;">
                    <v-text-field v-model="level" label="Level" clearable outlined dense/>
                </v-col>
                <v-col cols="2" md="2" style="height: 50px;">
                    <v-select v-model="difficulty" :items="['Easy', 'Medium', 'Hard']" label="Difficulty" clearable outlined dense small-chips/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="12" style="height: 50px;">
                    <v-btn class="mr-4" @click="submit" align="left">submit</v-btn>
                </v-col>
            </v-row>
            <br><hr>
            <v-row>
                <v-col cols="1" style="height: 50px;">
                    <v-subheader>Level</v-subheader>
                </v-col>
                <v-col cols="2" style="height: 50px;">
                    <v-text-field v-model="levelStart" label="start" hint="" persistent-hint clearable outlined dense/>
                </v-col>
                <v-col cols="2" style="height: 50px;">
                    <v-text-field v-model="levelEnd" label="end" hint="" persistent-hint clearable outlined dense/>
                </v-col>
                <v-col cols="2" style="height: 50px;">
                    <v-btn class="mr-4" @click="submitInt(levelStart, levelEnd, 'level')" align="left">submit</v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="1" style="height: 50px;">
                    <v-subheader>Value</v-subheader>
                </v-col>
                <v-col cols="2" style="height: 50px;">
                    <v-text-field v-model="valueStart" label="start" hint="" persistent-hint clearable outlined dense/>
                </v-col>
                <v-col cols="2" style="height: 50px;">
                    <v-text-field v-model="valueEnd" label="end" hint="" persistent-hint clearable outlined dense/>
                </v-col>
                <v-col cols="2" style="height: 50px;">
                    <v-btn class="mr-4" @click="submitInt(valueStart, valueEnd, 'value')" align="left">submit</v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="1" style="height: 50px;">
                    <v-subheader>Created</v-subheader>
                </v-col>
                <v-col cols="2" style="height: 50px;">
                    <v-menu ref="menu1" v-model="dateStartMenu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="computedDateFormattedStart" label="start" persistent-hint prepend-inner-icon="mdi-calendar" v-bind="attrs" v-on="on" clearable outlined dense/>
                        </template>
                        <v-date-picker v-model="dateStart" no-title @input="dateStartMenu = false"/>
                    </v-menu>
                </v-col>
                <v-col cols="2" class="d-flex align-center">
<!--                    <v-card flat height="50" width="20"><strong>-</strong></v-card>-->
                    <v-menu v-model="dateEndMenu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="computedDateFormattedEnd" label="end" persistent-hint prepend-inner-icon="mdi-calendar" v-bind="attrs" v-on="on" clearable outlined dense/>
                        </template>
                        <v-date-picker v-model="dateEnd" no-title @input="dateEndMenu = false"/>
                    </v-menu>
                    <!--                        <p>Date in ISO format: <strong>{{ date }}</strong></p>-->
                </v-col>
                <v-col cols="2" style="height: 50px;">
                    <v-btn class="mr-4" @click="submitTimestamp(dateStart, dateEnd, 'created')" align="left">submit</v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col md="12">
                    <v-data-table
                            dense
                            :headers="headers"
                            :items="items"
                            :items-per-page=20
                            :footer-props="{'items-per-page-options': [10, 20, 50, 100, -1]}"
                            :search="search"
                            style="white-space: nowrap"
                    >
                        <template v-slot:top>
                            <v-toolbar flat>
                                <v-toolbar-title>Users</v-toolbar-title>
                                <v-divider class="mx-2" inset vertical/>
                                <!--                    <v-btn @click="createItem" class="ma-2" color="primary">-->
                                <!--                        New User-->
                                <!--                    </v-btn>-->
                                <v-spacer/>
                                <v-text-field
                                        append-icon="search"
                                        hide-details
                                        label="Search"
                                        single-line
                                        v-model.trim="search"
                                />
                            </v-toolbar>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-card-text>
        <!--        <v-product-dialog ref="product-dialog"/>-->
    </v-card>
</template>

<script>
    import database from "../store/database";
    import dayJS from 'dayjs';
    import relativeTime from 'dayjs/plugin/relativeTime';
    import * as firebase from 'firebase/app'

    dayJS.extend(relativeTime);

    export default {
        name: "GameItemEvents",
        //components: {VProductDialog},
        data: (vm) => ({
            search: "",
            headers: [
                { text: "Id", value: "userId"},
                { text: "Event", value: "gameEvent"},
                { text: "Source", value: "source"},
                { text: "Location", value: "location"},
                { text: "Item", value: "item"},
                { text: "Value", value: "value"},
                { text: "Game", value: "game"},
                { text: "Level", value: "level"},
                { text: "Difficulty", value: "difficulty"},
                { text: "Platform", value: "platform"},
                { text: "App version", value: "version"},
                { text: "Created", value: "created"},
            ],
            items: [],

            userId: '',
            platform:'',
            appVersion: '',
            dateCreated:'',
            difficulty:'',
            game:'',
            level:'',
            gameEvent:'',
            location:'',
            source:'',
            item:'',
            value:'',

            valueStart:'',
            valueEnd:'',
            levelStart:'',
            levelEnd:'',

            dateStart: '',//new Date().toISOString().substr(0, 10),
            dateEnd: '',//new Date().toISOString().substr(0, 10),
            dateUpdatedFormattedStart: '',//vm.formatDate(new Date().toISOString().substr(0, 10)),
            dateUpdatedFormattedEnd: '',//vm.formatDate(new Date().toISOString().substr(0, 10)),
            dateStartMenu: false,
            dateEndMenu: false,
        }),
        computed: {
            computedDateFormattedStart: {
                get: function () {
                    return this.formatDate(this.dateStart)
                },
                set: function (newValue) {
                    this.dateStart = newValue
                }
            },
            computedDateFormattedEnd : {
                get: function () {
                    return this.formatDate(this.dateEnd)
                },
                set: function (newValue) {
                    this.dateEnd = newValue
                }
            },
        },
        watch: {
            dateUpdatedStart (val) {
                this.dateUpdatedFormattedStart = this.formatDate(this.dateStart)
            },
            dateUpdatedEnd (val) {
                this.dateUpdatedFormattedEnd = this.formatDate(this.dateEnd)
            },
        },
        methods: {
            submit () {
                let collection = database.collection("game_item_events")
                if( this.userId ){
                    collection = collection.where("user_id", "==", this.userId)
                }
                if( this.appVersion ){
                    collection = collection.where("version", "==", this.appVersion)
                }
                if( this.platform ){
                    collection = collection.where("platform", "==", this.platform.toLowerCase())
                }
                if( this.difficulty ){
                    collection = collection.where("difficulty", "==", this.difficulty.toLowerCase())
                }
                if( this.gameEvent ){
                    collection = collection.where("event", "==", this.gameEvent.toLowerCase())
                }
                if( this.game ){
                    collection = collection.where("game", "==", this.game.toLowerCase())
                }
                if( this.level ){
                    collection = collection.where("level", "==",  parseInt(this.level))
                }
                if( this.location ){
                    collection = collection.where("location", "==", this.location.toLowerCase())
                }
                if( this.source ){
                    collection = collection.where("source", "==", this.source)
                }
                if( this.item ){
                    collection = collection.where("item", "==",  this.item.toLowerCase())
                }
                if( this.value ){
                    collection = collection.where("value", "==",  parseInt(this.value))
                }
                this.getCollection(collection)
            },
            submitInt(startFrom, endFrom, fieldPath){
                let collection = database.collection("game_item_events")
                if( startFrom ){
                    collection = collection.where(fieldPath, ">=", parseInt(startFrom) )
                }
                if( endFrom ) {
                    collection = collection.where(fieldPath, "<=", parseInt(endFrom))
                }
                //collection = collection.orderBy("coins").limit(1)
                this.getCollection(collection)
            },
            submitTimestamp(from, to, fieldPath){
                let collection = database.collection("game_item_events")
                if( from ){
                    collection = collection.where(fieldPath, ">=", firebase.firestore.Timestamp.fromDate(new Date(from)))
                }
                if( to ) {
                    collection = collection.where(fieldPath, "<=", firebase.firestore.Timestamp.fromDate(new Date(to)))
                }
                //collection = collection.orderBy("coins").limit(1)
                //firebase.firestore.Timestamp.fromDate(new Date("December 10, 1815"))
                this.getCollection(collection)
            },
            getCollection(collection){
                this.items = []
                //.orderBy("created")
                collection.get()
                    .then((querySnapshot) => {
                        querySnapshot.forEach((doc) => {
                            //console.log(`${doc.id} => ${ Object.values(doc.data())}`);
                            let data = doc.data()
                            this.items.push({
                                created: data.created ? dayJS(data.created.toDate()).fromNow() : '', //created: dayJS(data.created.toDate()).fromNow(),
                                userId: data.user_id,
                                platform: data.platform,
                                version: data.version,
                                time: data.time,
                                level: data.level,
                                game: data.game,
                                gameEvent: data.event,
                                difficulty: data.difficulty,
                                location: data.location,
                                source: data.source,
                                item: data.item,
                                value: data.value,
                            })
                        });
                    }).catch((error) => {
                    console.log(error)
                });  //store.getters["database/getProducts"];
            },
            formatDate (date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            },
            parseDate (date) {
                if (!date) return null

                const [month, day, year] = date.split('/')
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            },
        },
        created() {
            //this.items = []// StoreHelper.getProducts()
        }
    };
</script>